<script lang="ts" setup>
import PaymentPopupDefault from './PaymentPopup.default.vue'
import PaymentPopupNovelarc from './PaymentPopup.novelarc.vue'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

defineProps<{
  value: boolean
  contentId: string
  contentChapterId: string
  bookName: string
  chapterName: string
  serialStatus: number
}>()

defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'success'): void
}>()

// 动态加载品牌组件
const PaymentPopupComponent = loadBrandComponent({
  rocnovel: PaymentPopupDefault,
  oceread: PaymentPopupDefault,
  ficmoon: PaymentPopupDefault,
  novelarc: PaymentPopupNovelarc,
  storyella: PaymentPopupNovelarc,
  silktale: PaymentPopupNovelarc,
  pearla: PaymentPopupNovelarc,
  fictora: PaymentPopupDefault,
  marinovel: PaymentPopupDefault,
})
</script>

<template>
  <PaymentPopupComponent
    :value="value"
    :content-id="contentId"
    :content-chapter-id="contentChapterId"
    :book-name="bookName"
    :chapter-name="chapterName"
    :serial-status="serialStatus"
    @input="value => $emit('input', value)"
    @success="$emit('success')"
  />
</template>
